import { Route, Routes, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { SxProps, Theme } from "@mui/material";
import "./App.css";
import Homepage from "./pages/Homepage";
import AboutUsPage from "./pages/AboutUsPage";
import AccreditationPage from "./pages/AccreditationPage";
import Header from "./components/Header";
import MyThemeProvider from "./MyThemeProvider";
import AccreditationDetailPage from "./pages/AccreditationDetailPage";
import CareersPage from "./pages/CareersPage";
import CareersJobPositionPage from "./pages/CareersJobPositionPage";
import CareersJobPositionDetailPage from "./pages/CareersJobPositionDetailPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import GalleryPage from "./pages/GalleryPage";
import StartupIncubatorPage from "./pages/StartupIncubatorPage";
import TestingStandardPage from "./pages/TestingStandardPage";
import RedirectToBackendPage from "./pages/RedirectToBackendPage";
import { useIsMobile } from "./hooks";
import smoothscroll from 'smoothscroll-polyfill';
import Footer from "./components/Footer";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import WhistleblowingPage from "./pages/WhistleblowingPage";
import TestingTechnologyPage from "./pages/TestingTechnologyPage";
import PartnershipsPage from "./pages/PartnershipsPage";
import RedirectPage from "./pages/RedirectPage";


const AppStyle: Record<string, SxProps<Theme>> = {
    container: {
        // padding: "30px",
        paddingLeft: "100px",
        paddingRight: "100px",
    },
    containerMobile: {
        padding: "10px",
        paddingLeft: "10px",
        paddingRight: "10px",
        // border: "1px solid green",
        // margin: "4px"
    },
    containerGallery: {
        paddingLeft: "0px",
        paddingRight: "0px",
        // height: "calc(100vh - 100px)",
        overflow: "hidden",
        // minHeight: "1000px",
    }
};

function App() {
    const { isMobile } = useIsMobile();
    smoothscroll.polyfill();

    const { pathname } = useLocation();

    return (
        <StyledEngineProvider injectFirst>
            <MyThemeProvider>
                <div
                    className="App"
                    style={{
                        background: "linear-gradient(to bottom, #413a56, #221f2d)",
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Header />
                    <Box
                        sx={[{flex: 1},
                        isMobile ? AppStyle.containerMobile : AppStyle.container,
                        pathname.includes("/gallery") ? AppStyle.containerGallery : {},
                        ].flat(2)}
                    >
                        <Routes>
                            <Route path="/" element={<Homepage/>}/>
                            <Route path="/about-us" element={<AboutUsPage/>}/>
                            <Route path="/testing">
                                <Route index element={<TestingTechnologyPage content="test"/>}/>
                                <Route path="search-standard/:standardQuery" element={<TestingStandardPage/>}/>
                            </Route>
                            <Route path="/software" element={<TestingTechnologyPage content="tech"/>}/>
                            <Route path="/accreditations">
                                <Route index element={<AccreditationPage/>}/>
                                <Route path=":accreditationType/list" element={<AccreditationDetailPage/>}/>
                            </Route>
                            <Route path="/news">
                                <Route index element={<BlogPage/>}/>
                                <Route path=":blogId/detail" element={<BlogDetailPage/>}/>
                            </Route>

                            <Route path="/partners" element={<PartnershipsPage/>}/>
                            <Route path="/startup-incubator" element={<StartupIncubatorPage/>}/>
                            <Route path="/careers">
                                <Route index element={<CareersPage/>} />
                                <Route path="positions" element={<CareersJobPositionPage/>}/>
                                <Route path="positions/:positionId/detail" element={<CareersJobPositionDetailPage/>}/>
                                {/* <Route path="positions/apply" element={<CareersJobPositionApplyPage />}/> */}
                            </Route>
                            <Route path="/gallery" element={<GalleryPage/>}/>
                            <Route path="/contact" element={<ContactPage/>}/>
                            <Route path="/whistleblowing" element={<WhistleblowingPage/>}/>
                            <Route path="/privacy" element={<PrivacyPolicyPage/>}/>
                            <Route path="/files/:filename" element={<RedirectToBackendPage/>}/>
                            <Route path="/it/*" element={<RedirectPage/>}/>
                        </Routes>
                    </Box>
                    <Footer/>
                </div>
            </MyThemeProvider>
        </StyledEngineProvider>
    );
}

export default App;
